import React from 'react';
import { scrollToUDS } from '../helpers';

const PaymentError = () => {
	return (
		<span
			className="ddc-font-size-xsmall text-muted text-decoration-underline"
			onClick={scrollToUDS}
			onKeyDown={(e) => {
				// role="button" should activate on both Enter and Space;
				// preventDefault stops Space from also scrolling the page
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					scrollToUDS();
				}
			}}
			role="button"
			tabIndex={0}
		>
			N/A
		</span>
	);
};

export default PaymentError;
